import { useEffect, useState } from "react";

/**
 * Masaüstü eşiği — Tailwind'in `lg` breakpoint'iyle AYNI değer (CLOS-97 `[058]`).
 *
 * ⚠ İki yerde tanımlanmamalı. JS `1024` derken CSS `lg` başka bir değer olsaydı aradaki
 * bantta sidebar hem gizli hem kapalı kalır ve kullanıcı gezinmeye hiç ulaşamazdı —
 * kartın *"kritik navigasyon kaybolmaz"* kriterinin en sinsi ihlali.
 */
export const DESKTOP_MIN_WIDTH = 1024;
const SORGU = `(min-width: ${DESKTOP_MIN_WIDTH}px)`;

/**
 * Masaüstü genişliğinde miyiz?
 *
 * ### Neden CSS'e bırakılmadı
 *
 * Sırf `hidden lg:flex` kullanmak sunumu çözerdi ama davranışı çözmezdi: drawer açıkken
 * ekran büyürse panel görünmez olur, odak kapanı ise AKTİF kalırdı — klavye kullanıcısı
 * göremediği bir panelin içine hapsolurdu. Tek karar noktası bunu yapısal olarak
 * engelliyor: masaüstünde `Drawer` hiç render edilmiyor.
 */
export function useIsDesktop(): boolean {
  const [desktop, setDesktop] = useState(() =>
    typeof window === "undefined" ? true : window.matchMedia(SORGU).matches,
  );

  useEffect(() => {
    const mq = window.matchMedia(SORGU);
    const guncelle = (e: MediaQueryListEvent) => setDesktop(e.matches);
    // İlk değer state başlatıcısında okundu; arada değişmiş olabilir, senkronla.
    setDesktop(mq.matches);
    mq.addEventListener("change", guncelle);
    return () => mq.removeEventListener("change", guncelle);
  }, []);

  return desktop;
}
